import type { FormValueEventInstance } from "@/widgets/classic-form/form";
import { applyExactEventDefaults } from "@/widgets/classic-form/form";

interface MapEventInstanceWithExactnessProps {
    instance: FormValueEventInstance;
    isYearExactnessEnabled: boolean;
    isPlaceExactnessEnabled: boolean;
    matchAllTermsExactly: boolean;
    isEditForm: boolean;
    defaultYearProximity: number | null;
}

/** Edit-form prefill leaves the user's exactness alone, never forcing it exact or applying the default year proximity (TT-1919). */
export const mapEventInstanceWithExactness = ({
    instance,
    isYearExactnessEnabled,
    isPlaceExactnessEnabled,
    matchAllTermsExactly,
    isEditForm,
    defaultYearProximity,
}: MapEventInstanceWithExactnessProps): FormValueEventInstance => {
    const forceExact = matchAllTermsExactly && !isEditForm;
    const copy = applyExactEventDefaults(instance, {
        exactDate: forceExact && isYearExactnessEnabled,
        exactPlace: forceExact && isPlaceExactnessEnabled,
    });

    const hasDefaultYearProximity = defaultYearProximity !== null;
    const isYearMissing = typeof copy.date.year !== "number";
    if (isYearExactnessEnabled && hasDefaultYearProximity && isYearMissing && !matchAllTermsExactly) {
        copy.dateProximity = {
            year: defaultYearProximity,
            month: 0,
            day: 0,
        };
    }
    return copy;
};
